import React from "react";
import ReactDatePicker from "../../../../../components/reactDatePicker/reactDatePicker";
import { actionCreators } from "../redux/averageClassSizeByInstructorSagas";
import { useDispatch, useSelector } from "react-redux";

const DatePicker = () => {
  const dispatch = useDispatch();
  let { startDate, endDate } = useSelector(
    (state) => state.averageClassSizeByInstructor.selectedRequestDates
  );
  let { calendarEndDate, calendarStartDate } = useSelector(
    (state) => state.averageClassSizeByInstructor.currentUser
  );

  let updateDates = (startDate, endDate) =>
    dispatch(actionCreators.updateDates({ startDate, endDate }));

  return (
    <ReactDatePicker
      showDefaultInputIcon={false}
      isRangePicker
      startDate={startDate}
      endDate={endDate}
      calendarEndDate={calendarEndDate}
      minDate={calendarStartDate}
      updateDates={updateDates}
    />
  );
};

export default DatePicker;
